import React, { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
// import api
import { getProfile } from '../api/admin';

const HelperRouter = () => {
    // hooks
    const dispatch = useDispatch();

    // redux-state
    const { isAuth } = useSelector((state) => state.auth);

    // function
    useEffect(() => {
        if (isAuth) {
            getProfile(dispatch)
        }
    }, [isAuth, dispatch])
    return <div />;
}

export default HelperRouter;